import styled from 'styled-components';

import { BasicSubtitle } from '@genially/design-system';

interface CommonProps {
  $isDisabled?: boolean;
}

export const Wrapper = styled.div<CommonProps>(({ theme: { size }, $isDisabled }) => ({
  display: 'flex',
  gap: size.units(1),
  cursor: $isDisabled ? 'default' : 'pointer',
}));

export const StyledIcon = styled.span<CommonProps>(
  ({ theme: { color, size }, $isDisabled }) => ({
    width: size.units(2),
    height: size.units(2),
    minWidth: size.units(2),
    minHeight: size.units(2),
    color: color.content.reversed.default($isDisabled ? 0.3 : 1),
  }),
);

export const StyledBasicSubtitle = styled(BasicSubtitle)<CommonProps>(
  ({ theme: { color }, $isDisabled }) => ({
    color: color.content.reversed.default($isDisabled ? 0.3 : 1),
  }),
);
